import { render, staticRenderFns } from "./edit-trade-modal.vue?vue&type=template&id=2babb10b&scoped=true&"
import script from "./edit-trade-modal.vue?vue&type=script&lang=js&"
export * from "./edit-trade-modal.vue?vue&type=script&lang=js&"
import style0 from "./edit-trade-modal.vue?vue&type=style&index=0&id=2babb10b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2babb10b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VIcon,VSelect,VTextField})
